import AppNotificationsController from './app.notifications.controller';

const appNotificationModule = angular.module('app.appNotification',[
	//THIRD PARTY
    'ui.router',
    'ui.bootstrap',
    'ui.router',
    'ncy-angular-breadcrumb',
    'gettext'
])
.controller('AppNotificationsController', AppNotificationsController)
;

export default appNotificationModule.name;